<script setup lang="ts">
import {
  DataSetDto,
  instanceOfEnumerationDataSetDto,
  instanceOfNumericDataSetDto,
} from '@/api/generator';
import { computed, useAttrs } from 'vue';
import NumericTrendChart from './NumericTrendChart.vue';
import EnumerationTrendChart from './EnumerationTrendChart.vue';

interface TrendChartProps {
  dataset: DataSetDto;
  showInJobContext?: boolean;
  markedEvaluationResultIds?: string[];
}

const props = defineProps<TrendChartProps>();
const attrs = useAttrs();

const numericDataset = computed(() =>
  instanceOfNumericDataSetDto(props.dataset) ? props.dataset : null,
);

const enumerationDataset = computed(() =>
  instanceOfEnumerationDataSetDto(props.dataset) ? props.dataset : null,
);
</script>

<template>
  <NumericTrendChart
    v-if="numericDataset"
    v-bind="attrs"
    :showInJobContext="showInJobContext"
    :datasets="[numericDataset]"
    :markedEvaluationResultIds="markedEvaluationResultIds"
  />
  <EnumerationTrendChart
    v-if="enumerationDataset"
    v-bind="attrs"
    :showInJobContext="showInJobContext"
    :datasets="[enumerationDataset]"
    :markedEvaluationResultIds="markedEvaluationResultIds"
  />
</template>
